import React from 'react';
import { motion } from 'framer-motion';
const painPoints = [{
  emoji: '💸',
  title: 'Your sales are up, but your bank account tells a different story.',
  description: 'Revenue keeps coming in and it still feels like you are not making progress. Platform fees, ad spend, refunds and product costs are taking more than you think.'
}, {
  emoji: '⏱️',
  title: 'Save time to invest more on your business operations.',
  description: 'No more losing on sales, efficiency on your routine and more importantly, momentum. Every time it happens, postponing might not be the best option.'
}, {
  emoji: '🚀',
  title: '5 minutes of your time can boost your business.',
  description: 'Unload your agenda, plan that next campaign, discover new routes and more extensions for your business. Time is priceless, and you know it.'
}];
export function ProblemSection() {
  return <section className="bg-white py-16 sm:py-20" data-id="element-204">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-205">

        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-206">
          <span className="text-xs font-bold tracking-[0.2em] uppercase text-[#0084A8] mb-4 block" data-id="element-207">
            Does This Sound Familiar?
          </span>
          <h2 className="font-display font-extrabold text-3xl sm:text-4xl text-gray-900 leading-tight" data-id="element-208">
            Track Your Real Profit
            <br className="hidden sm:block" data-id="element-209" />
            <span className="text-[#0084A8]" data-id="element-210"> in No Time</span>
          </h2>
        </motion.div>

        {/* Pain point cards */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-211">
          {painPoints.map((point, i) => <motion.div key={point.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.12,
          duration: 0.5
        }} whileHover={{
          y: -4
        }} className="bg-gray-50 rounded-2xl p-6 border-l-4 border-[#00C9B1] hover:shadow-lg transition-all duration-300 cursor-default" data-id="element-212">
              <span className="text-3xl block mb-4" data-id="element-213">{point.emoji}</span>
              <h3 className="font-display font-bold text-base sm:text-lg text-gray-900 mb-3 leading-snug" data-id="element-214">
                {point.title}
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed" data-id="element-215">
                {point.description}
              </p>
            </motion.div>)}
        </div>

        {/* Bridge */}
        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="text-center text-gray-500 text-base mt-10" data-id="element-216">
          You did not start this business to become an accountant.{' '}
          <strong className="text-gray-800 font-semibold" data-id="element-217">
            That is exactly why we built this.
          </strong>
        </motion.p>
      </div>
    </section>;
}